<template>
  <h1
    class="choice-title"
    v-if="$store.getters?.getQuesInfo?.type === 1 && data?.isRequired"
    :class="{
      required: $store.getters?.getQuesInfo?.type === 1 && data?.isRequired,
    }"
  >
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
      `${quesIndex + 1}、`
    }}</span>
    {{ data?.title }}
    <span
      v-if="$store.getters?.isShowType && data.questionType !== 12 && data.questionType !== 13"
      class="title-tip"
    >
      (单选题)</span
    >
  </h1>
  <h1 class="choice-title" v-else :class="{ required: showAnswerRequired }">
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
      `${quesIndex + 1}、`
    }}</span>
    {{ data?.title }}
    <span
      v-if="$store.getters?.isShowType && data.questionType !== 12 && data.questionType !== 13"
      class="title-tip"
    >
      {{ data.questionType === 19 ? '(判断题)' : '(单选题)' }}
    </span>
  </h1>
  <div v-if="data.url" class="img-list">
    <li
      v-for="(item, index) in data.url && JSON.parse(data.url)"
      :key="`${item.url}${index}`"
    >
      <img
        @click="handleImgPreview(data.url && JSON.parse(data.url), index)"
        class="title-img animate__animated animate__fadeIn"
        v-if="isImage(item.url)"
        :src="item.url"
        alt=""
      />
      <video
        class="title-video"
        controls
        v-else
        :poster="item.poster"
        :src="item.url"
        alt=""
      ></video>
    </li>
  </div>
  <Radio-Group class="choice" v-model="checked" @change="handleRadioChange">
    <template v-for="(item, index) in data?.optionVoList" :key="item.optionKey">
      <Radio
        class="choice-item"
        :name="item.optionKey"
        :disabled="
          $store.getters?.getQuesInfo?.type === 1 && item.display === false
        "
      >
        <img
          v-if="item?.isUrl === 1"
          style="max-width: 7rem; margin: 0.4rem 0"
          :src="item.content"
          alt=""
        />
        <template v-else>
          {{ String.fromCharCode(65 + index) }}.{{ item.content }}
          <span
            class="choice-item-limit-tips"
            v-if="
              $store.getters?.getQuesInfo?.type === 1 && item.chance !== null
            "
            >{{ handleFormatlimitTips(item.chance) }}</span
          >
        </template>
        <template #icon="props">
          <div class="circle" :class="{ select: props.checked }"></div>
        </template>
      </Radio>
      <Field
        v-model="inputValue"
        @update:model-value="handleInputChange"
        v-show="checked == item.optionKey && item.isBlank == 1"
        style="border-bottom: 1px solid #e0e0e0"
        :disabled="isReview"
        :placeholder="item.remark ? item.remark : '请输入不满意原因'"
        type="textarea"
        rows="2"
        autosize
        border
      />
    </template>
  </Radio-Group>
  <div
    v-if="
      $store.getters.getQuesInfo.type === 3 &&
      data.questionType !== 12 &&
      data.questionType !== 13
    "
  >
    <div v-if="(showFeedBack && checked) || isReview">
      <template class="feedback animate__animated animate__fadeInDown">
        <div class="left green" v-if="checked == rightAnswer.optionKey">
          答案：正确
        </div>
        <div class="left red" v-else>答案：错误</div>
        <div v-if="type !== '1'" class="right">
          正确答案：{{ rightAnswer.index }}
        </div>
      </template>
      <div
        v-if="
          data?.explanation &&
          $store.getters.getQuesSetting?.isExplanation === 2
        "
        class="explanation"
      >
        <img src="@/assets/img/explanation.png" alt="" />
        <p>解析：{{ data.explanation }}</p>
      </div>
    </div>
  </div>
</template>

<script>
// 多选和单选的样式是一样的 提出来了
import './css/choice.scss'
import { RadioGroup, Radio, Field, ImagePreview } from 'vant'
import { ref, onMounted, watch } from 'vue'
import { onBeforeRouteUpdate } from 'vue-router'
import { useImagePreview } from '@/hooks/index.js'
import { getQueryString, isImage, getAnswer, handleFormatlimitTips } from '@/utils/tools'

// 正确选项设置
const rightAnswerEffect = (data, rightAnswer) => {
  data.optionVoList.forEach((item, index) => {
    if (item.isRight) {
      rightAnswer.value.index = String.fromCharCode(65 + index)
      rightAnswer.value.optionKey = item.optionKey
    }
  })
}

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    quesIndex: {
      type: Number,
      default: 0,
    },
    currentChecked: {
      type: String,
      default: '',
    },
    // 临时处理答题个人题型必填显示
    showAnswerRequired: {
      type: Number,
      default: 0,
    },
    showFeedBack: {
      type: Boolean,
      default: false,
    },
    isReview: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['changeChoice', 'radioSelect', 'singleSubmit'],
  components: { RadioGroup, Radio, Field },
  setup(props, ctx) {
    const checked = ref('')

    const rightAnswer = ref({
      optionKey: '',
      index: '',
    })

    const inputValue = ref('')

    // 处理选项更改
    const handleRadioChange = (name) => {
      // 单个题
      ctx.emit('changeChoice', name)
      // 列表题
      const emitData = {
        value: [name],
        questionKey: props.data.questionKey,
        questionType: props.data.questionType,
      }
      if (props.data.questionType === 12 || props.data.questionType === 13) {
        const res = props.data.optionVoList.filter(
          (item) => item.optionKey === name
        )[0]
        if (res) {
          emitData.answerContent = res.content
        }
      }
      // 单选填空
      const res = props.data.optionVoList.filter(
        (item) => item.optionKey === checked.value
      )[0]
      if (res && res.isBlank === 1) {
        emitData.remarkContent = inputValue.value
      }
      ctx.emit('radioSelect', emitData)

      const isStudy = getQueryString('isStudy')
      // 单个题学习模式下，选择即反馈
      if (isStudy && name) {
        ctx.emit('singleSubmit')
      }
    }

    // 处理input变化
    const handleInputChange = () => {
      const res = props.data.optionVoList.filter(
        (item) => item.optionKey === checked.value
      )[0]
      const emitData = {
        value: [checked.value],
        questionKey: props.data.questionKey,
        questionType: props.data.questionType,
      }
      if (res && res.isBlank === 1) {
        emitData.remarkContent = inputValue.value
      }
      ctx.emit('radioSelect', emitData)
    }

    watch(
      () => props.data,
      (n) => {
        rightAnswerEffect(props.data, rightAnswer)
      }
    )

    // 切换单多选时候会触发
    onMounted(() => {
      checked.value = props.currentChecked

      if (props.data.localChecked) {
        checked.value = props.data.localChecked
      }

      const localAnswer = getAnswer(props.data.questionKey)
      if (localAnswer) {
        checked.value = localAnswer[0]?.optionKey
      }

      rightAnswerEffect(props.data, rightAnswer)

      if (props.isReview) {
        const filterContent = props.data.optionVoList.filter(
          (item) => item.optionKey === props.currentChecked
        )
        inputValue.value = filterContent[0] && filterContent[0].remarkContent
      }
    })

    // 连续多个相同题型时会触发
    onBeforeRouteUpdate(() => {
      checked.value = props.currentChecked
    })

    // 为了判断正式考试回顾不显示正确答案
    const type = getQueryString('type')

    // 图片预览展示
    const { handleImgPreview } = useImagePreview()

    return {
      checked,
      rightAnswer,
      inputValue,
      handleRadioChange,
      type,
      handleInputChange,
      handleImgPreview,
      isImage,
      handleFormatlimitTips,
    }
  },
}
</script>
